<template>
  <UDropdownMenu
    :items="items"
    :content="{ align: 'center', collisionPadding: 12 }"
    :ui="{ content: collapsed ? 'w-40' : 'w-(--reka-dropdown-menu-trigger-width)' }"
  >
    <UButton
      v-bind="{
        ...teams.selected,
        trailingIcon: collapsed ? undefined : 'i-lucide-chevrons-up-down',
      }"
      color="neutral"
      variant="ghost"
      block
      :square="collapsed"
      class="data-[state=open]:bg-elevated"
      :class="[!collapsed && 'py-2']"
      :ui="{
        trailingIcon: 'text-dimmed',
      }"
    >
      <div class="flex flex-wrap gap-2 items-center">
        <NavbarTeamsMenuPreview v-if="!isAdmin" />
        <NavbarTeamsMenuAdminPreview v-else />
      </div>
    </UButton>
  </UDropdownMenu>
</template>

<script setup lang="ts">
import type { DropdownMenuItem } from '@nuxt/ui'

defineProps<{
  collapsed?: boolean
}>()

const teams = useTeamsStore()
const user = useUserStore()

const items = ref<DropdownMenuItem[]>([])

const route = useRoute()
const isAdmin = computed(() => {
  return route.path.startsWith('/admin')
})

onMounted(async () => {
  if (teams.teams.length === 0) {
    await teams.getAll()
  }
  teams.teams.forEach((t) => {
    items.value.push({
      label: t.name,
      onSelect: () => {
        teams.selected = t
        return navigateTo('/portal')
      },
    })
  })
  items.value.push({
    label: 'Settings',
    icon: 'i-lucide-settings',
    to: '/portal/teams',
  })
  items.value.push({
    label: 'New team',
    icon: 'i-lucide-plus',
    to: '/portal/teams/create',
  })
  user.checkAdmin().then((isAdmin: boolean) => {
    if (isAdmin) {
      items.value.push({
        label: 'Admin',
        icon: 'i-lucide-lock',
        to: '/admin',
      })
    }
  })
})
</script>
